import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerAchUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.ach.update),
			switchMap((action) =>
				this.consumerAdminService
					.updateBankAccountName(action.accountId, action.accountName)
					.pipe(
						map(() => ConsumerAdminActions.ach.updateSuccess()),
						catchError((error) =>
							of(ConsumerAdminActions.ach.updateFail(new FailState(error)))
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
